<template>
	<div>
		<template v-if="isLaptop">
			<b-modal
				id="saveAs"
				size="lg"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				v-model="showModal"
				@hidden="$emit('close-modal'), $emit('open-mob-create')"
			>
				<div class="d-flex" ref="fillFormModal">
					<div class="w-100">
						<div class="candash-modal-top p-3 pl-4">
							<div class="width-97">
								<div class="candash-modal-head">Create New Profile</div>
							</div>
							<div
								class="pointer"
								@click="$emit('close-modal'), $emit('open-mob-create')"
							>
								<img
									class="rotate-on-hover"
									src="../../assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
						</div>
						<div class="p-3 candash-modal-body-9">
							<div class="d-flex align-items-start">
								<div>
									<img
										src="../../assets/newdesign/dashboard/creaNewPro.svg"
										alt=""
									/>
								</div>
								<div class="w-75 pl-4">
									<div class="candash-blackTxt">Profile Name</div>
									<div class="w-100 mt-2">
										<b-form-input
											placeholder="Enter name of the resume"
											type="text"
											v-model="$v.resumeName.$model"
											:class="
												$v.resumeName.$error
													? 'laptopinput-error'
													: 'laptopinput'
											"
											autofocus
										>
										</b-form-input>
										<div
											v-if="!$v.resumeName.maxLength && $v.resumeName.required"
											class="candash-errortxt errortxt-pos"
										>
											Exceeded the max char length of 20
										</div>
									</div>
								</div>
							</div>
							<div class="candash-light-txt-2 mt-4 ml-1">
								Would you like to create the new profile from Primary Profile?
							</div>

							<!-- class for blue class  pad-radio -->
							<div
								class="d-flex align-items-center candash-light-txt-3 ml-1 mt-2 lh-25"
							>
								<!-- <div class="pad-radio-red">
                  <b-form-radio size="sm">Yes</b-form-radio>
                </div>
                <div class="ml-4 pad-radio mb-1">
                  <b-form-radio size="sm">No</b-form-radio>
                </div> -->
								<b-form-group v-slot="{ ariaDescribedby }">
									<b-form-radio-group
										id="radio-group-1"
										v-model="$v.selectedPrimaryOption.$model"
										:options="isPrimary"
										:aria-describedby="ariaDescribedby"
										name="radio-options"
										:class="
											$v.selectedPrimaryOption.$error
												? 'pad-radio-red'
												: 'pad-radio'
										"
										@change="handleRadioChange"
									></b-form-radio-group>
								</b-form-group>
							</div>

							<hr class="hr-background" />
							<div class="greytxt-3 ml-1">
								If yes, Please Choose the sections you wish to retain in the new
								profile
							</div>
							<div class="candash-light-txt-3 mt-2 ml-1">
								Primary profile forms
							</div>
							<div
								class="d-flex align-items-center flex-wrap position-relative mt-3 ml-1"
							>
								<div
									v-for="(tab, index) in tabOption"
									:key="index"
									:class="
										!selectedPrimaryOption
											? 'tab-tag-disable'
											: tabNameList.includes(tab.formID) &&
											  tab.formID !== 'personalDetails' &&
											  tab.formID !== 'demographics'
											? 'tab-tag-active pointer'
											: tabNameList.includes(tab.formID)
											? 'tab-tag-active defaultCursor'
											: 'tab-tag-notSelected pointer'
									"
									class="tab-tag"
									@click="
										selectedPrimaryOption &&
										tab.formID !== 'personalDetails' &&
										tab.formID !== 'demographics'
											? addTabName(tab.formID)
											: ''
									"
								>
									<img
										v-if="
											tabNameList.includes(tab.formID) &&
											tab.formID !== 'personalDetails' &&
											tab.formID !== 'demographics'
										"
										class="mr-2"
										src="../../assets/newdesign/dashboard/blueTick.svg"
										alt=""
									/>

									<img
										v-else-if="
											tab.formID !== 'personalDetails' &&
											tab.formID !== 'demographics'
										"
										class="mr-2"
										src="../../assets/newdesign/dashboard/plus.svg"
										alt=""
									/>
									<span>
										{{
											tab.formName == "Portfolio Links"
												? "Portfolio"
												: tab.formName
										}}
									</span>
								</div>

								<div
									v-if="
										($v.resumeName.$dirty && !$v.resumeName.required) ||
										($v.selectedPrimaryOption.$dirty &&
											!$v.selectedPrimaryOption.required)
									"
									class="candash-errortxt d-flex align-items-center bottom-37"
								>
									<img
										class="mr-2"
										src="../../assets/newdesign/dashboard/modalAlert.svg"
										alt=""
									/>Please fill the required fields
								</div>
								<div
									v-if="invalidSelection"
									class="candash-errortxt d-flex align-items-center bottom-37"
								>
									<img
										class="mr-2"
										src="../../assets/newdesign/dashboard/modalAlert.svg"
										alt=""
									/>Please select at least one option
								</div>
							</div>
						</div>
						<div
							class="candash-modal-footer d-flex align-items-center justify-content-end"
						>
							<b-button
								@click="$emit('close-modal'), $emit('open-mob-create')"
								class="candash-cancelBtn mr-4 pointer"
								>Cancel</b-button
							>
							<div class="position-relative">
								<b-button
									@click="createNewResumeProfile()"
									class="candash-addBtn"
									:class="
										!delCheck ? 'loader-class-delete defaultCursor' : 'pointer'
									"
								>
									{{ !delCheck ? "" : "Create" }}
								</b-button>
								<div v-if="!delCheck" class="loader-pos-new">
									<Loader />
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-modal>
		</template>
		<div
			class="create-profile-box"
			v-if="showModal && !isLaptop"
			style="height: auto"
		>
			<section class="h-100">
				<div class="profile-heading">
					<img
						@click="$emit('close-modal'), $emit('open-mob-create')"
						src="@/assets/newbuilder/backarw.svg"
						class="mr-1"
						alt=""
					/>
					Create New Profile
				</div>
				<div class="d-flex align-items-start mt-3">
					<div>
						<img src="@/assets/newbuilder/createNewpro.svg" alt="" />
					</div>
					<div class="w-75 pl-3">
						<div class="candash-blackTxt">Profile Name</div>
						<div class="w-100 mt-1">
							<b-form-input
								placeholder="Enter name of the resume"
								type="text"
								autofocus
								v-model="$v.resumeName.$model"
								:class="
									$v.resumeName.$error ? 'laptopinput-error' : 'laptopinput'
								"
							>
							</b-form-input>
							<div
								v-if="!$v.resumeName.maxLength && $v.resumeName.required"
								class="candash-errortxt errortxt-pos"
							>
								Exceeded the max char length of 20
							</div>
						</div>
					</div>
				</div>
				<div class="d-flex align-items-center mt-3">
					<div class="candash-light-txt-2 ml-1 w-61">
						Would you like to create the new profile from Primary Profile?
					</div>
					<div class="d-flex align-items-center candash-light-txt-3 ml-1">
						<b-form-group v-slot="{ ariaDescribedby }">
							<b-form-radio-group
								id="radio-group-1"
								v-model="$v.selectedPrimaryOption.$model"
								:options="isPrimary"
								:aria-describedby="ariaDescribedby"
								name="radio-options"
								:class="
									$v.selectedPrimaryOption.$error
										? 'pad-radio-red'
										: 'pad-radio'
								"
								@change="handleRadioChange"
							></b-form-radio-group>
						</b-form-group>
					</div>
				</div>
				<hr class="hr-background" />
				<div class="greytxt-3 ml-1">
					If yes, Please Choose the sections you wish to retain in the new
					profile
				</div>
				<div class="candash-light-txt-3 mt-2 ml-1">Primary profile forms</div>
				<div
					class="d-flex align-items-center flex-wrap position-relative mt-3 ml-1"
				>
					<div
						v-for="(tab, index) in tabOption"
						:key="index"
						class="tab-tag"
						:class="
							!selectedPrimaryOption
								? 'tab-tag-disable'
								: tabNameList.includes(tab.formID) &&
								  tab.formID !== 'personalDetails' &&
								  tab.formID !== 'demographics'
								? 'tab-tag-active pointer'
								: tabNameList.includes(tab.formID)
								? 'tab-tag-active defaultCursor'
								: 'tab-tag-notSelected pointer'
						"
						@click="
							selectedPrimaryOption &&
							tab.formID !== 'personalDetails' &&
							tab.formID !== 'demographics'
								? addTabName(tab.formID)
								: ''
						"
					>
						<img
							v-if="
								tabNameList.includes(tab.formID) &&
								tab.formID !== 'personalDetails' &&
								tab.formID !== 'demographics'
							"
							class="mr-2"
							src="../../assets/newdesign/dashboard/blueTick.svg"
							alt=""
						/>

						<img
							v-else-if="
								tab.formID !== 'personalDetails' &&
								tab.formID !== 'demographics'
							"
							class="mr-2"
							src="../../assets/newdesign/dashboard/plus.svg"
							alt=""
						/>
						<span>
							{{
								tab.formName == "Portfolio Links" ? "Portfolio" : tab.formName
							}}
						</span>
					</div>
				</div>
				<div
					v-if="
						($v.resumeName.$dirty && !$v.resumeName.required) ||
						($v.selectedPrimaryOption.$dirty &&
							!$v.selectedPrimaryOption.required)
					"
					style="position: unset"
					class="candash-errortxt d-flex align-items-center bottom-37 mb-1"
				>
					<img
						class="mr-2"
						src="../../assets/newdesign/dashboard/modalAlert.svg"
						alt=""
					/>Please fill the required fields
				</div>
				<div
					v-if="invalidSelection"
					class="candash-errortxt d-flex align-items-center bottom-37"
				>
					<img
						class="mr-2"
						src="../../assets/newdesign/dashboard/modalAlert.svg"
						alt=""
					/>Please select at least one option
				</div>
				<!-- use the below div for integration which is exactly same as create profile integration above div is to check the design u can remove that once u integrate it -->

				<div
					class="candash-modal-footer px-0 pb-0 d-flex align-items-center justify-content-end"
				>
					<b-button
						class="candash-cancelBtn mr-4 pointer"
						@click="$emit('close-modal'), $emit('open-mob-create')"
						>Cancel</b-button
					>
					<div class="position-relative">
						<b-button
							class="candash-addBtn"
							@click="createNewResumeProfile()"
							:class="
								!delCheck ? 'loader-class-delete defaultCursor' : 'pointer'
							"
						>
							{{ !delCheck ? "" : "Create" }}
						</b-button>
						<div v-if="!delCheck" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { resumeValidations } from "../../controllers/dashboard/validations";
import Loader from "../../components/fixedcomponents/Loader.vue";
import { getProfileTopTabs, postAllProfiles } from "../../utils/apiFunctions";
import toast from "../mixin/toast";
export default {
	name: "CreateNewProfile",
	mixins: [toast],
	data() {
		return {
			tabOption: [],
			tabNameList: [],

			resumeName: null,
			selectedPrimaryOption: null,
			delCheck: true,
			invalidSelection: false,

			isPrimary: [
				{ text: "Yes", value: true },
				{ text: "No", value: false },
			],
		};
	},
	props: {
		showModal: Boolean,
		isLaptop: Boolean,
	},
	components: {
		Loader,
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
	},
	validations() {
		return {
			...resumeValidations(this),
		};
	},
	created() {
		this.getTabOptions();
	},
	methods: {
		async getTabOptions() {
			let industry = this.candidateInfo.industry;
			if (industry == null) {
				industry = "IT/ITES";
			}
			try {
				const res = await getProfileTopTabs(industry, "clone");
				if (res.status == 200) {
					this.tabOption = res.data.data.forms;
				} else {
					console.log("Error Api");
				}
			} catch (error) {
				console.log("Error", error);
			}
		},
		handleRadioChange() {
			if (!this.selectedPrimaryOption) {
				this.tabNameList = [];
			} else {
				this.tabNameList.push("personalDetails", "demographics");
			}
		},
		addTabName(formIds) {
			if (this.tabNameList.includes(formIds)) {
				const index = this.tabNameList.indexOf(formIds);
				if (index > -1) {
					this.tabNameList.splice(index, 1);
				}
			} else {
				this.tabNameList.push(formIds);
				this.invalidSelection = false;
			}
			// this.$forceUpdate();
		},
		async createNewResumeProfile() {
			this.delCheck = false;
			this.$v.$touch();
			if (this.selectedPrimaryOption && this.tabNameList < 1) {
				this.invalidSelection = true;
			} else {
				this.invalidSelection = false;
			}
			if (!this.$v.$invalid && !this.invalidSelection) {
				try {
					let payload = {
						profileName: this.resumeName,
						createNew: this.selectedPrimaryOption,
						cloneFields: this.tabNameList,
					};
					const resp = await postAllProfiles(payload);
					if (resp.status == 201) {
						const ids = resp.data.data._id;
						this.$emit("close-modal");
						this.$emit("change-profile", ids);
					} else if (resp.status == 404) {
						this.errorModal("Error", "Profile not found");
					} else if (resp.status == 409) {
						this.errorModal("Error", "Profile name already exist");
					}
				} catch (error) {
					console.log(error);
				}
			} else {
				this.errorModal("Error", "Please fill all the details");
			}
			this.delCheck = true;
		},
	},
};
</script>

<style></style>
